import React, {useContext} from "react";
import "./pagination.scss";
import {Pagination as MuiPagination} from "@mui/material";
import {storesContext} from "../../../stores/stores";
import {observer} from "mobx-react";

interface PaginationProps {
    currentPage: number;
    onPageChange: (event: any, offset: number) => void;
}

function Pagination(props: PaginationProps) {
    const paginationStore = useContext(storesContext).paginationStore;
    const [page, setPage] = React.useState(props.currentPage+1);

    const handleChangePage = (event: React.ChangeEvent<unknown> | null, newPage: number) => {
        if (props.onPageChange) {
            const offset = paginationStore.size * (newPage-1);
            paginationStore.setOffset(offset);
            props.onPageChange(event, offset);
        }

        setPage(newPage);
    };

    return (
        <div className="pagination-container">
            <MuiPagination
                page={page}
                count={paginationStore.numberOfPages}
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handleChangePage}
                showFirstButton
                showLastButton
            />
        </div>
    );
}

export default observer(Pagination);